import React from 'react';

import ColorInput from '../base/ColorInput';

type Props = {
  label: string;
  name: string;
};
export default function Color({ label, name }: Props) {
  return <ColorInput label={label} name={name} />;
}
